import { Component, ViewChild } from "@angular/core";
import { ModalComponent } from "../../components/modal/modal.component";
import { Tag } from "../../models/tag.model";
import { TagService } from "../../services/tag.service";
import * as _ from "underscore";
import { ToastService } from "../../components/toast/toast.service";

@Component({
  selector: "lowy-bulk-add-tags-modal",
  template: `
    <lowy-modal #modal>
      <div class="form">
        <div class="headline">Bulk Add Search Tags</div>
        <div style="height:35px"></div>
        <mat-spinner *ngIf="loading"></mat-spinner>
        <div class="inline-mat-form" *ngIf="!loading">
          <lowy-dropdown
            label="Patient Tag"
            (add)="selectedTag = $event"
            placeholder="Tag"
            [data]="patientTags"
            singleItemSelection="true"
            fullWidth="true"
          ></lowy-dropdown>
        </div>

        <mat-chip-list class="tag-list">
          <mat-chip *ngIf="selectedTag" class="type-tag tag-to-count">{{
            selectedTag?.name
          }}</mat-chip>
        </mat-chip-list>

        <mat-form-field>
          <textarea
            matInput
            matTextareaAutosize
            matAutosizeMinRows="2"
            matAutosizeMaxRows="5"
            placeholder="Patient IDs"
            [(ngModel)]="patientIds"
            [ngModelOptions]="{ standalone: true }"
          ></textarea>
        </mat-form-field>

        <div class="row" *ngIf="!loading">
          <div class="col-2">
            <button mat-button class="lowy-btn-clear" (click)="close()">
              cancel
            </button>
          </div>
          <div class="col-2">
            <button mat-button class="lowy-btn-std" (click)="submit()">
              save
            </button>
          </div>
        </div>
      </div>
    </lowy-modal>
  `,
  providers: [TagService],
})
export class BulkAddTagsModalComponent {
  public loading: boolean;
  public patientTags: Tag[];
  public selectedTag: Tag;
  public patientIds: string;

  @ViewChild("modal") modal: ModalComponent;

  constructor(
    private tagService: TagService,
    private toastService: ToastService
  ) {}

  public async open() {
    this.modal.open();
    this.loading = true;
    this.patientTags = await this.tagService.getTags(); // TODO patient only
    this.loading = false;
  }

  public close() {
    this.loading = false;
    this.selectedTag = null;
    this.patientIds = null;
    this.modal.close();
  }

  public async submit() {
    this.loading = true;
    let patientIdArr;
    if (this.patientIds && this.patientIds.length > 0) {
      // save patientIds as array, allow comma separated or newline separated
      patientIdArr = _.uniq(
        this.patientIds
          .split(/[\s,]+/)
          .map((str) => str.trim())
          .filter((str) => str !== "")
      );
    }

    await this.tagService.bulkAddTags(this.selectedTag.tagId, patientIdArr);
    this.toastService.throwToast(
      "Tags added, will take several minutes before they are searchable."
    );
    this.loading = false;

    this.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/bulk-add-tags/bulk-add-tags-modal.component.ts